import { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const SharedSearchInputStyles = css`
    background-color: ${colorsPalettes.carbon[0]};
    border: none;
    width: 100%;
    box-sizing: border-box;
    padding: 9px 2px 5px 50px;
    box-shadow: none;
    margin-bottom: 0;

    &:focus {
        box-shadow: none !important;
        border: none;
    }
`;
